type IconProps = {
  size?: string
  fill?: string
  stroke?: string
}

export function CheckBoxRounded({ size }: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#F5F7FF" />
      <circle cx="8" cy="8" r="3" fill="#3E54B8" />
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#3E54B8" />
    </svg>
  )
}

export function LinkArrow({ size }: IconProps) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 11L11 1M11 1H4.33333M11 1V7.66667"
        stroke="#2D3D85"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LeftArrow({ fill, stroke }: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={fill || 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8332 10H4.1665M4.1665 10L9.99984 15.8334M4.1665 10L9.99984 4.16669"
        stroke={stroke || '#344054'}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function RightArrow({ fill, stroke }: IconProps) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill={fill || 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.1665 10.5001H15.8332M15.8332 10.5001L9.99984 4.66675M15.8332 10.5001L9.99984 16.3334"
        stroke={stroke || '#344054'}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
